import { z } from "zod";

import { ALL_CALCULATIONS, type Calculation } from "~/tools/calculate-value-from-points";
import { ImpulseFormUnit } from "~/tools/impulse-form";

const LAST = "last" satisfies Calculation;

type WidgetCalculation = ImpulseFormUnit<string, ReadonlyArray<string>, Calculation>;

function init(initial = LAST): WidgetCalculation {
	return ImpulseFormUnit(initial, {
		schema: z.enum(ALL_CALCULATIONS),
	});
}

const WidgetCalculation = {
	default: LAST,
	init,
} as const;

export { WidgetCalculation };
